<div mat-dialog-title>
  <div class="right">
    <button
      mat-button
      aria-label="close"
      [mat-dialog-close]="false"
      class="close-button"
    >
      <mat-icon aria-hidden="true" aria-label="close security modal"
        >close</mat-icon
      >
    </button>
  </div>
  <h2 class="modal-title" [id]="secureHeadingId">
    Your Information is Secure
  </h2>
</div>

<mat-dialog-content align="center" class="security-info-dialog">
  <div class="security-icon"></div>
  <div>
    <p>
      We're dedicated to protecting both your money and your online privacy.
    </p>
    <p>
      Read our
      <a target="_blank" rel="noopener noreferrer" [href]="privacyUrl"
        class="link-btn-action">Privacy Policy</a
      >
      to learn more about how we keep your data and information secure.
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
  class="primary-btn-action"
    mat-flat-button
    color="primary"
    id="dialog-close-button"
    mat-dialog-close
  >
    OK
  </button>
</mat-dialog-actions>
